//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObjectCollection.js";
import "../no/Offset.js";
import "../no/SmartObject.js";
import "../no/ugmath.js";
import "../no/BasePart.js";
let d=[[],[[["origin","vector","update_option"],"CreateOffset",{R_:{offset:"Offset"}},3,0],[["delta_x","delta_y","delta_z","update_option"],"CreateOffsetRectangular",{R_:{offset:"Offset"}},4,0],[["radius","angle","delta_z","update_option"],"CreateOffsetCylindrical",{R_:{offset:"Offset"}},4,0],[["radius","angle1","angle2","update_option"],"CreateOffsetSpherical",{R_:{offset:"Offset"}},4,0],[["direction","distance","update_option"],"CreateOffset1",{R_:{offset:"Offset"}},3,0],[["icurve","t","update_option"],"CreateCurvature",{R_:{curvature:"Offset"}},3,0],[["atPoint","icurve","update_option"],"CreateCurvatureAtPoint",{R_:{curvature:"Offset"}},3,0],[["icurve","t","update_option"],"CreateCurvatureDerivative",{R_:{curvature_derivative:"Offset"}},3,0],[["atPoint","icurve","update_option"],"CreateCurvatureDerivativeAtPoint",{R_:{curvature_derivative:"Offset"}},3,0],[["face","u","v","absolute_uv","option","section_direction","update_option"],"CreateCurvature1",{R_:{curvature:"Offset"}},7,0],[["face","u","v","absolute_uv","option","section_direction","update_option"],"CreateCurvatureDerivative1",{R_:{curvature_derivative:"Offset"}},7,0],[["atPoint","face","option","section_direction","update_option"],"CreateCurvatureAtPoint1",{R_:{curvature:"Offset"}},5,0],[["atPoint","face","option","section_direction","update_option"],"CreateCurvatureDerivativeAtPoint1",{R_:{curvature_derivative:"Offset"}},5,0],[["face","u","v","absolute_uv","section_angle","update_option"],"CreateCurvature2",{R_:{curvature:"Offset"}},6,0],[["face","u","v","absolute_uv","section_angle","update_option"],"CreateCurvatureDerivative2",{R_:{curvature_derivative:"Offset"}},6,0],[["offset_in","xform","update_option"],"CreateOffsetExtract",{R_:{offset:"Offset"}},3,0]],[]];
SPLM.OffsetCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.OffsetCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;